/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

const actionTypes = {
  // Cart Action
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_ITEM: "REMOVE_ITEM",
  CLEAR_CART: "CLEAR_CART",
  CHECK_UN_APPROVED_ITEMS: "CHECK_UN_APPROVED_ITEMS",
  CHANGE_QUANTITY: "CHANGE_QUANTITY",
  CHECK_PROMO_BAN: "CHECK_PROMO_BAN",
  CHANGE_DISCOUNT: "CHANGE_DISCOUNT",

  CHANGE_CATEGORY: "CHANGE_CATEGORY",
  CHANGE_PARTNER: "CHANGE_PARTNER",

  // Authenticate Action
  AUTHENTICATE: "AUTHENTICATE",
  SET_TENANT_ID: "SET_TENANT_ID",
  SET_TENANT_DATA: "SET_TENANT_DATA",
  SET_TENANT_LOCALE: "SET_TENANT_LOCALE",
  ECOMMERCE_CUST_DATA: "ECOMMERCE_CUST_DATA",
  SET_PUBLIC_BROWSING: "SET_PUBLIC_BROWSING",
  SET_ENABLED_MODULES: "SET_ENABLED_MODULES",
  SET_GENERIC_REPORTS: "SET_GENERIC_REPORTS",
  UPDATE_USER_NAME_DATA: "UPDATE_USER_NAME_DATA",
  SET_DEFAULT_COUNTRY: "SET_DEFAULT_COUNTRY",
  SET_ENABLED_FEATURES: "SET_ENABLED_FEATURES",

  // Refresh Token Action
  REFRESH_USER_TOKEN: "REFRESH_USER_TOKEN",

  // Authorize Action
  AUTHORIZE: "AUTHORIZE",

  // GlobalHandler
  SET_ERROR_MSG: "SET_ERROR_MSG",
  GLOBAL_COMP_DID_MOUNT: "GLOBAL_COMP_DID_MOUNT",
  SET_CART: "SET_CART",
  SET_TENANT_INFO: "SET_TENANT_INFO",
  SET_COUNTRIES_LIST: "SET_COUNTRIES_LIST",
  SET_QUOTE: "SET_QUOTE",
  SET_MENU_DRAWER_OPEN: "SET_MENU_DRAWER_OPEN",
  SET_PENDING_TASK_COUNT: "SET_PENDING_TASK_COUNT",
  SET_MODULES: "SET_MODULES",
  SET_SIDE_MENU: "SET_SIDE_MENU",
};

export default actionTypes;
